export default "__VITE_ASSET__CpHVTfSP__"